import { useState } from "react";
import type { Destino, FormatoDaPlanilha } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { paraImportar, type LinhaMontada } from "./montar";

const LOTE = 500;

/** Grava a importação: abre (criando as categorias novas) e manda as linhas em lotes de 500. */
export function useImportar() {
  const utils = trpc.useUtils();
  const iniciar = trpc.financeiro.importacao.iniciar.useMutation();
  const lote = trpc.financeiro.importacao.lote.useMutation();
  const [progresso, setProgresso] = useState<{ feitos: number; total: number } | null>(null);

  async function importar(arquivo: string, formato: FormatoDaPlanilha, linhas: LinhaMontada[]) {
    // Uma categoria nova por rótulo + destino ("Material" como saída de Custo dos serviços).
    const chaveNova = (rotulo: string, d: Destino) => (d.acao === "criar" ? `${rotulo}|${d.tipo}|${d.linha}` : "");
    const novas = new Map<string, { chave: string; nome: string; tipo: "ENTRADA" | "SAIDA"; linhaDoDre: NonNullable<LinhaMontada["linha"]> }>();
    for (const l of linhas) {
      if (l.destino.acao !== "criar") continue;
      const chave = chaveNova(l.lida.rotulo, l.destino);
      novas.set(chave, { chave, nome: l.lida.rotulo.slice(0, 60).padEnd(2, "."), tipo: l.destino.tipo, linhaDoDre: l.destino.linha });
    }
    const aberta = await iniciar.mutateAsync({ arquivo: arquivo.slice(0, 200), formato, novasCategorias: [...novas.values()] });
    const prontas = linhas.map((l) => paraImportar(l, l.destino.acao === "categoria" ? l.destino.id : aberta.categorias[chaveNova(l.lida.rotulo, l.destino)]!));
    let criados = 0;
    setProgresso({ feitos: 0, total: prontas.length });
    for (let i = 0; i < prontas.length; i += LOTE) {
      const r = await lote.mutateAsync({ importacaoId: aberta.importacaoId, linhas: prontas.slice(i, i + LOTE) });
      criados += r.criados;
      setProgresso({ feitos: Math.min(i + LOTE, prontas.length), total: prontas.length });
    }
    setProgresso(null);
    await utils.financeiro.invalidate();
    return { criados, importacaoId: aberta.importacaoId };
  }

  return { importar, progresso, pendente: iniciar.isPending || lote.isPending };
}
